import React, { useEffect, useState } from 'react'
import useCustomAlert from './Alert2';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBundleTenureByDeviceId } from '../services/PrequalificationService';
import { hideModal } from '../redux/features/oxygen/customModalSlice';

const FBNBundleModal = ({data}) => {
    const {device_type_id, onClick, tenure} = data;
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const [deviceBundles, setDeviceBundles] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const userId = useSelector((state) => state?.user?.user?.id);
    const precustomer =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
    const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
    const bundles = deviceBundles?.selected_device?.bundles || [];
    const otpLoading = useSelector((state) => state.oxygenRetail?.otpLoading);

    const handleFetchBundleByDeviceId = async () => {

        const payload = { 
            mssidn: String(precustomer?.msisdn),
            device_type_id: Number(device_type_id),
            financier_id: String(financierID), 
            store_id: 0,
            precustomer_id: Number(precustomer?.precustomerId),
            credit_limit: "", 
            useMinCreditLimit:true, 
            repId: Number(userId),
            tenure: Number(tenure),
        };

       try {
            setLoading(true);
            setErrorMessage("");    
            const response = await fetchBundleTenureByDeviceId(payload);

            if (response?.status) {
                setErrorMessage("");  
                setDeviceBundles(response?.data);
            } else {
                setDeviceBundles({});
                setErrorMessage(response?.message || "Failed to fetch device bundles..!");
                customAlert.showToast("error", response?.message || "Failed to fetch device bundles..!");
            }
        } catch (err) {
            setDeviceBundles({});
            setErrorMessage(err?.message || "Network error. Please try again.");
        } finally {
            setLoading(false);
        }

    };


    useEffect(() => {
        handleFetchBundleByDeviceId();
    }, [device_type_id]);


    return (
        <div className="card mb-10 border-0 shadow-md p-3"
        style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}>
            {
                loading ? (
                <p className='text-center'>Fetching bundles...</p>
            ):errorMessage ? (
                <div className="alert alert-danger" role="alert">
                {errorMessage}
            </div>
            ):(
                <div className="row px-3 px-md-7"
                    style={{
                        maxHeight: "calc(100vh - 120px)",
                        overflowY: "auto",
                    }}
                >
                {bundles?.map((bundle) => (
                    <div key={bundle?.id} className="col-12 mb-4">   {/* <-- full width */}
                    <div className="card rounded-4 border-0 shadow-lg p-3 w-100">
                        <h6 className="fw-bold text-primary">{bundle?.bundle_name}</h6>

                        <ul className="list-unstyled small font-weight-bold px-3">
                        <li className="py-2">
                            <strong>Monthly Payment:</strong> ₦
                            {bundle?.monthly_payt?.toLocaleString()}
                        </li>

                        <li className="py-2">
                            <strong>Down Payment:</strong> ₦
                            {bundle?.down_payt?.toLocaleString() || 0}
                        </li>

                        <li className="py-2">
                            <strong>Duration Months:</strong> {bundle?.duration_months}
                        </li>

                        <li className="py-2">
                            <strong>Voice Minutes:</strong> {bundle?.voice_mins} mins
                        </li>

                        <li className="py-2">
                            <strong>Data Quantity:</strong> {bundle?.data_qty}
                        </li>

                        <li className="py-2 font-weight-light">
                            Total Repayment: ₦{bundle?.total_repayt?.toLocaleString()}
                        </li>
                        </ul>

                        <div className="mt-3 px-3 d-flex justify-content-end">
                        <button
                            className="btn btn-primary"
                            onClick={() => onClick(bundle, device_type_id)}
                        >
                            { otpLoading ? "Submitting..." : "Select Bundle"}
                        </button>
                        </div>
                    </div>
                    </div>
                ))}
                </div>
            )
            }

            <div className="mt-3 mb-3 px-3 form-group d-flex justify-content-start">
                <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
                <b>Cancel</b>
                </button>
            </div>
        </div>
    )
}

export default FBNBundleModal;